var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("bootstrap-box", {
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("h3", { staticClass: "box-header" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.resource(
                          "PushNotifications_Index_CreateNotification_Header"
                        )
                      ) +
                      "\n            "
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _c("create", {
                  on: { "notification-created": _vm.refreshNotifications }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("bootstrap-box", {
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("h3", { staticClass: "box-header" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.resource(
                          "PushNotifications_Index_NotificationsList_Header"
                        )
                      ) +
                      "\n            "
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [_c("list", { ref: "notificationList" })]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }